import {useMutation} from "react-query";
import {UpdateGroupCommand} from "../../models/group";
import groupService from "../../services/GroupService";

export default function useUpdateGroup() {
   return useMutation((request: UpdateGroupCommand) => groupService.update(request));
}